import RestaurantCardList, { RestaurantCardListProps } from './RestaurantCardList';

export type { RestaurantCardListProps };
export default RestaurantCardList;
